import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

interface User {
  _id: string;
  email?: string;
  phone?: string;
  role: 'user' | 'artist' | 'admin';
  displayName?: string;
  referredByCode?: string;
  createdAt: string;
}

export default function Users() {
  const [q, setQ] = useState('');
  const { data } = useQuery<{ items: User[] }>({
    queryKey: ['admin', 'users', q],
    queryFn: () => api(`/api/v1/admin/users?q=${encodeURIComponent(q)}`),
  });
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Users</h1>
      <input
        placeholder="Search email / phone / name…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="w-full max-w-md mb-6 bg-surface border border-border rounded-md px-3 py-2"
      />
      <div className="bg-surface border border-border rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-surface2 text-left text-text2">
            <tr>
              <th className="px-4 py-3">Email / phone</th>
              <th className="px-4 py-3">Role</th>
              <th className="px-4 py-3">Referred by</th>
              <th className="px-4 py-3">Created</th>
            </tr>
          </thead>
          <tbody>
            {(data?.items ?? []).map((u) => (
              <tr key={u._id} className="border-t border-border">
                <td className="px-4 py-3">{u.email ?? u.phone}</td>
                <td className="px-4 py-3">
                  <span
                    className={`px-2 py-0.5 rounded-full text-xs ${
                      u.role === 'admin' ? 'bg-accent text-bg' : u.role === 'artist' ? 'bg-accentDim text-bg' : 'bg-surface2'
                    }`}
                  >
                    {u.role}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-xs">{u.referredByCode ?? '–'}</td>
                <td className="px-4 py-3">{new Date(u.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
